import React, { useEffect, useState, useMemo } from "react";
import {
  Container, Typography, Button, Dialog, DialogTitle,
  DialogContent, DialogActions, TextField, FormControl,
  InputLabel, Select, MenuItem, Paper, Box, CircularProgress,  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { db, storage } from "./firebase";
import { collection, getDocs } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { apiFetch, API_BASE } from "./utils/apiClient";
import { toDateSafe } from "./utils/toDateSafe";
import { useBoxStaff, withBoxStaffNames } from "./utils/useBoxStaff";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UploadPreview, { appendPickedFiles } from "./components/UploadPreview";
import RichTextEditor from "./components/RichTextEditor";
import TaskText from "./components/TaskText";
import ConfirmDialog from "./components/ConfirmDialog";
import { plainTextToHtml } from "./utils/richText";



// اسم العرض بقائمة "إضافة تاسك" - القيمة المحفوظة تبقى نفس الاسم (برهان/يوسف)
// لأن صفحات مهامهم تقرا التاسكات بهذا الاسم
const TASK_EMPLOYEE_LABELS = { "برهان": "الورشة", "يوسف": "المصمم" };
// موظفات سابقات ما تنضافلهم تاسكات جديدة (تاسكاتهم القديمة تبقى ظاهرة)
const NO_NEW_TASK_EMPLOYEES = ["جمانا", "فرح", "مياسة", "ساره", "رند"];

const BASE_EMPLOYEES = [  "انوار","بنين","مياسة","تيهان","جمانا","يوسف","برهان","فرح","ساره","رند"];

const TasksDashboard = () => {
  // + موظفات البوكسات (الحسابات الجديدة مثل تيهان) تلقائياً
  const boxStaff = useBoxStaff();
  const EMPLOYEES = withBoxStaffNames(BASE_EMPLOYEES, boxStaff);
  const [allTasks, setAllTasks] = useState([]);
  const [open, setOpen] = useState(false);
  const [taskText, setTaskText] = useState("");
  const [taskHtml, setTaskHtml] = useState(""); // نسخة منسّقة من الوصف (textHtml)
  const [editorKey, setEditorKey] = useState(0); // تغييره يعيد تحميل المحرر بقيمة جديدة
  const [deleteTarget, setDeleteTarget] = useState(null); // التاسك المطلوب حذفه (لنافذة التأكيد)
  const [isDeleting, setIsDeleting] = useState(false);
  const [taskEmployee, setTaskEmployee] = useState("انوار");
  const [taskDeadline, setTaskDeadline] = useState("");
  const [taskImages, setTaskImages] = useState([]);
  const [taskFiles, setTaskFiles] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeEmployeeFilter, setActiveEmployeeFilter] = useState(null); // null = الكل
const [commentOpen, setCommentOpen] = useState(false);
const [commentText, setCommentText] = useState("");
const [activeTask, setActiveTask] = useState(null);
const [commentImages, setCommentImages] = useState([]);
const [commentFiles, setCommentFiles] = useState([]);
const [previewImage, setPreviewImage] = useState(null);
const [isUploadingComment, setIsUploadingComment] = useState(false);
const [editMode, setEditMode] = useState(false);
const [editingTask, setEditingTask] = useState(null);
const [taskPriority, setTaskPriority] = useState("Medium");
const [commentNewStatus, setCommentNewStatus] = useState("");
const getPriorityStyle = (priority) => {
  switch (priority) {
    case "High":
      return { bg: "#f8d7da", color: "#842029", label: "HIGH" };
    case "Medium":
      return { bg: "#fff3cd", color: "#664d03", label: "MEDIUM" };
    case "Low":
      return { bg: "#d1e7dd", color: "#0f5132", label: "LOW" };
    default:
      return { bg: "#e2e3e5", color: "#41464b", label: "-" };
  }
};
const [existingImages, setExistingImages] = useState([]);
const [existingFiles, setExistingFiles] = useState([]);

const USERNAME_MAP = {
  "rand@123": "رند",
  "jumana@123": "جمانا",
  "sara@123": "ساره",
  "Baneen@123": "بنين",
  "Farah@123":"فرح",
  "maryam@123": "مريم",
  "designer@123": "المصمم",
  "art@1234": "الورشة",
  "admin": "المدير",
  "karina@123": "تيهان",
  "halima@123": "الرسام",
  "janat@123": "جَنان",
  "maysa@123": "مياسة"
};

// حدد المستخدم الحالي
const rawUser = localStorage.getItem("username") || "غير معروف";
const currentUser = USERNAME_MAP[rawUser] || rawUser;



  useEffect(() => {
    fetchTasks();
    
  }, []);

  const fetchTasks = async () => {
    const res = await apiFetch(`${API_BASE}/tasks`);
    const data = await res.json();

    if (!res.ok) {
      console.error("❌ خطأ في جلب التاسكات:", data.error);
      return;
    }

    // ترتيب تنازلي حسب وقت الإنشاء
    data.sort((a, b) => (toDateSafe(b.createdAt)?.getTime() || 0) - (toDateSafe(a.createdAt)?.getTime() || 0));
    setAllTasks(data);
  };
const handleDeleteTask = async (taskId) => {
  try {
    const res = await apiFetch(`${API_BASE}/tasks/${taskId}`, { method: "DELETE" });

    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.error || "فشل حذف التاسك");
    }

    console.log("✅ تم حذف التاسك بنجاح");
    return true;
  } catch (err) {
    console.error("❌ خطأ أثناء الحذف:", err);
    alert("حدث خطأ أثناء حذف التاسك");
    return false;
  }
};

// 🗑️ تأكيد الحذف من النافذة
const confirmDeleteTask = async () => {
  if (!deleteTarget) return;
  setIsDeleting(true);
  const ok = await handleDeleteTask(deleteTarget.id);
  setIsDeleting(false);
  if (ok) {
    setAllTasks((prev) => prev.filter((t) => t.id !== deleteTarget.id));
    if (selectedTask?.id === deleteTarget.id) setSelectedTask(null);
  }
  setDeleteTarget(null);
};

// 🔹 تجيب توكن الموظف من قاعدة البيانات
const getEmployeeToken = async (employeeName) => {
  const snap = await getDocs(collection(db, "tokens"));
  const tokens = snap.docs.map((d) => d.data());
  const record = tokens.find((t) => t.employee === employeeName);
  return record ? record.token : null;
};

  const handleAddTask = async () => {
    try {
      if (!taskEmployee || !taskText.trim()) return;
      setIsSubmitting(true);

      let imageUrls = [];
      let fileUrls = [];

      for (const img of taskImages) {
        const imgRef = ref(storage, `tasks/images/${Date.now()}-${img.name}`);
        await uploadBytes(imgRef, img);
        imageUrls.push(await getDownloadURL(imgRef));
      }
      for (const f of taskFiles) {
        const fRef = ref(storage, `tasks/files/${Date.now()}-${f.name}`);
        await uploadBytes(fRef, f);
        fileUrls.push(await getDownloadURL(fRef));
      }

    const createRes = await apiFetch(`${API_BASE}/tasks`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        text: taskText.trim(),
        textHtml: taskHtml,
        employee: taskEmployee,
        deadline: taskDeadline || null,
        images: imageUrls,
        files: fileUrls,
        priority: taskPriority, // ⭐ جديد
        createdBy: "المدير",
        // status/createdAt/comments يثبّتها السيرفر تلقائياً (نفس القيم القديمة بالضبط)
      }),
    });

    if (!createRes.ok) {
      const errData = await createRes.json().catch(() => ({}));
      throw new Error(errData.error || "فشل إنشاء التاسك");
    }
// 🟢 إرسال إشعار إلى الموظف بعد إنشاء التاسك
try {
  await fetch("http://localhost:8080/send-to-user", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      uid: taskEmployee, // اسم الموظف مثل "رند" أو "يوسف"
      text: taskText.trim(), // نص المهمة
    }),
  });
  console.log("✅ تم إرسال إشعار التاسك إلى:", taskEmployee);
} catch (error) {
  console.error("❌ خطأ أثناء إرسال إشعار التاسك:", error);
}

      // تصفير الحقول
      setOpen(false);
      setTaskText("");
    setTaskHtml("");
      setTaskEmployee("انوار");
      setTaskDeadline("");
      setTaskImages([]);
      setTaskPriority("Medium");
      setTaskFiles([]);
      await fetchTasks();
    } catch (err) {
      console.error("❌ خطأ:", err);
      alert("حدث خطأ أثناء الإرسال");
    } finally {
      setIsSubmitting(false);
    }
  };
// ✅ تعديل التاسك الحالي
const handleUpdateTask = async (newStatus = null) => {
  if (!editingTask) return;

  try {
    setIsSubmitting(true);

    // رفع الصور الجديدة
    let newImageUrls = [];
    for (const img of taskImages) {
      const imgRef = ref(storage, `tasks/images/${Date.now()}-${img.name}`);
      await uploadBytes(imgRef, img);
      newImageUrls.push(await getDownloadURL(imgRef));
    }

    // رفع الملفات الجديدة
    let newFileUrls = [];
    for (const file of taskFiles) {
      const fRef = ref(storage, `tasks/files/${Date.now()}-${file.name}`);
      await uploadBytes(fRef, file);
      newFileUrls.push(await getDownloadURL(fRef));
    }

    const updateRes = await apiFetch(`${API_BASE}/tasks/${editingTask.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        text: taskText.trim(),
        textHtml: taskHtml,
        employee: taskEmployee,
        deadline: taskDeadline || null,
        priority: taskPriority, // تحديث الأولوية
        images: [...existingImages, ...newImageUrls],
        files: [...existingFiles, ...newFileUrls],
        status: newStatus ?? editingTask.status, // ⭐ المهم
        updatedAt: true,
      }),
    });

    if (!updateRes.ok) {
      const errData = await updateRes.json().catch(() => ({}));
      throw new Error(errData.error || "فشل تحديث التاسك");
    }

    alert("✅ تم تحديث التاسك بنجاح");

    setOpen(false);
    setEditMode(false);
    setEditingTask(null);
    setTaskText("");
    setTaskHtml("");
    setTaskEmployee("");
    setTaskDeadline("");
    setTaskImages([]);
    setTaskFiles([]);
    fetchTasks();
  } catch (err) {
    console.error("❌ خطأ أثناء تعديل التاسك:", err);
    alert("حدث خطأ أثناء حفظ التعديلات");
  } finally {
    setIsSubmitting(false);
  }
};

  // لون الكارت حسب الحالة + التأخير
  const getTaskColor = (task) => {
    if (task.deadline) {
      const deadlineDate = new Date(task.deadline);
      if (task.status !== "completed" && deadlineDate < new Date()) {
        return "#f8d7da"; // أحمر فاتح (متأخرة)
      }
    }
    if (task.status === "completed") return "#d4edda"; // أخضر
    if (task.status === "inProgress") return "#fff3cd"; // أصفر
    return "#e2e3e5"; // رمادي (pending)
  };

  const formatDateTime = (ts) => {
    const d = toDateSafe(ts);
    if (!d) return "—";
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    const hh = String(d.getHours()).padStart(2, "0");
    const mi = String(d.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}`;
  };

  // إحصائيات لكل موظف (من كل البيانات)
// --- [1] حساب الإحصائيات لكل موظف ---
const stats = useMemo(() => {
  return EMPLOYEES.map((emp) => {
    const empTasks = allTasks.filter((t) => t.employee === emp);
    return {
      employee: emp,
      total: empTasks.length,
      completed: empTasks.filter((t) => t.status === "completed").length,
      inProgress: empTasks.filter((t) => t.status === "inProgress").length,
      pending: empTasks.filter((t) => t.status === "pending").length,
    };
  });
}, [allTasks, EMPLOYEES.length]); // EMPLOYEES يزيد لما توصل أسماء موظفات البوكسات

// --- [2] حالة الفلتر ---
const [statusFilter, setStatusFilter] = useState("all");
const [priorityFilter, setPriorityFilter] = useState("all");
const [searchQuery, setSearchQuery] = useState("");
// all | completed | notCompleted

  // المهام المعروضة حسب الفلتر النشط
const visibleTasks = useMemo(() => {
  let tasks = allTasks;
  if (activeEmployeeFilter) {
    tasks = tasks.filter((t) => t.employee === activeEmployeeFilter);
  }

  if (statusFilter === "completed") {
    tasks = tasks.filter((t) => t.status === "completed");
  } else if (statusFilter === "notCompleted") {
    tasks = tasks.filter((t) => t.status !== "completed");
  }
 // ⭐ فلتر البرايورتي
  if (priorityFilter !== "all") {
    tasks = tasks.filter((t) => t.priority === priorityFilter);
  }
  // 🔍 فلتر البحث
  if (searchQuery.trim()) {
    const q = searchQuery.trim().toLowerCase();
    tasks = tasks.filter(
      (t) =>
        t.text?.toLowerCase().includes(q) ||
        t.employee?.toLowerCase().includes(q)
    );
  }
  return tasks;
}, [allTasks, activeEmployeeFilter, statusFilter, priorityFilter, searchQuery]);


  const isOverdue = (task) =>
    task.deadline &&
    new Date(task.deadline) < new Date() &&
    task.status !== "completed";

  return (
    <Container dir="rtl" sx={{ mt: 3 }}>
     {/* 🔹 أزرار Home وإضافة تاسك */}
<Box display="flex" flexDirection="column" alignItems="flex-start" mb={2}>
  {/* زر Home */}
  <Button
    variant="outlined"
    color="primary"
    sx={{ mb: 1 }}
    onClick={() => (window.location.href = "/admin")}
  >
    🏠 Home
  </Button>

  {/* العنوان الرئيسي */}
  <Typography variant="h4" gutterBottom sx={{ mb: 1 }}>
    🗒️ إدارة التاسكات
  </Typography>

  {/* زر إضافة تاسك */}
  <Button
    variant="contained"
    color="success"
onClick={() => {
  setEditMode(false);
  setEditingTask(null);

  setTaskText("");
    setTaskHtml("");
  setTaskEmployee("انوار");
  setTaskDeadline("");
  setTaskPriority("Medium");
  setTaskImages([]);
  setTaskFiles([]);
  setExistingImages([]);
  setExistingFiles([]);

  setEditorKey((k) => k + 1);
  setOpen(true);
}}  >
    ➕ إضافة تاسك
  </Button>
</Box>

      {/* بوكسات الإحصائيات */}
  <Box display="flex" gap={2} mb={3} flexWrap="wrap" mt={1}>
  {stats.map((s) => {
    const active = activeEmployeeFilter === s.employee;
    return (
      <Paper
        key={s.employee}
        onClick={() =>
          setActiveEmployeeFilter(active ? null : s.employee)
        }
        sx={{
          p: 2,
          cursor: "pointer",
          textAlign: "center",
          minWidth: 180,
          border: active ? "2px solid #1976d2" : "1px solid #e0e0e0",
          boxShadow: active ? 4 : 1,
          borderRadius: 2,
        }}
        elevation={active ? 3 : 1}
      >
        <Typography fontWeight={700}>{s.employee}</Typography>
        <Typography>📋 الكلي: {s.total}</Typography>
        <Typography>✅ مكتملة: {s.completed}</Typography>
        <Typography>🕒 قيد العمل: {s.inProgress}</Typography>
        <Typography>⏳ Pending: {s.pending}</Typography>
      </Paper>
    );
  })}
</Box>
<Box display="flex" gap={2} mb={3} flexWrap="wrap">

  {/* فلتر الحالة */}
  <FormControl sx={{ minWidth: 200 }}>
    <InputLabel>تصفية بالحالة</InputLabel>
    <Select
      value={statusFilter}
      label="تصفية بالحالة"
      onChange={(e) => setStatusFilter(e.target.value)}
    >
      <MenuItem value="all">الكل</MenuItem>
      <MenuItem value="completed">✅ المكتملة فقط</MenuItem>
      <MenuItem value="notCompleted">⏳ غير مكتملة</MenuItem>
    </Select>
  </FormControl>

  {/* فلتر الأولوية */}
  <FormControl sx={{ minWidth: 200 }}>
    <InputLabel>فلترة حسب الأولوية</InputLabel>
    <Select
      value={priorityFilter}
      label="فلترة حسب الأولوية"
      onChange={(e) => setPriorityFilter(e.target.value)}
    >
      <MenuItem value="all">الكل</MenuItem>
      <MenuItem value="High">🔴 High</MenuItem>
      <MenuItem value="Medium">🟡 Medium</MenuItem>
      <MenuItem value="Low">🟢 Low</MenuItem>
    </Select>
  </FormControl>

  {/* بحث */}
  <TextField
    sx={{ minWidth: 200 }}
    label="🔍 بحث"
    placeholder="ابحث عن تاسك..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
  />

</Box>

      {/* قائمة التاسكات */}
     <Box mt={2}>
 {visibleTasks.map((task) => {
  const p = getPriorityStyle(task.priority);

  return (
    
    <Paper
      key={task.id}
      sx={{
        p: 2,
        mb: 2,
        borderRadius: 2,
        backgroundColor: getTaskColor(task),
      }}
    >
      {/* 🗓️ السطر الأول */}
   {/* 🗓️ السطر الأول + Priority */}
<Box
  display="flex"
  justifyContent="space-between"
  alignItems="center"
  flexWrap="wrap"
>
  <Typography fontWeight={600}>
    🗓️ {formatDateTime(task.createdAt)} — الموظف : {task.employee} — الحالة : {task.status}
  </Typography>

  {/* Priority */}
  <Box
    sx={{
      display: "inline-flex",
      alignItems: "center",
      gap: 1,
      px: 2,
      py: 0.5,
      borderRadius: "20px",
      backgroundColor: getPriorityStyle(task.priority).bg,
      color: getPriorityStyle(task.priority).color,
      fontWeight: "bold",
      fontSize: 14,
      width: "fit-content"
    }}
  >
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        backgroundColor: getPriorityStyle(task.priority).color
      }}
    />
    {getPriorityStyle(task.priority).label}
  </Box>
</Box>

      {/* ⏳ السطر الثاني */}
      <Typography sx={{ mt: 0.5 }}>
        ⏳ : {task.deadline || "غير محدد"}
      </Typography>
{/* مرفقات التاسك الأصلية */}
{/* 📎 المرفقات المرسلة للموظف */}
{(task.images?.length > 0 || task.files?.length > 0) && (
  <Box mt={2}>
    <Typography fontWeight="bold">
      📎 المرفقات المرسلة للموظف
    </Typography>

    {task.images?.length > 0 && (
      <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
        {task.images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt="attachment"
            style={{
              width: 80,
              height: 80,
              objectFit: "cover",
              borderRadius: 6,
              cursor: "pointer",
              border: "1px solid #ccc",
            }}
            onClick={() => setPreviewImage(img)}
          />
        ))}
      </Box>
    )}

    {task.files?.length > 0 && (
      <Box mt={1}>
        {task.files.map((file, i) => (
          <Typography key={i} fontSize={14}>
            📎{" "}
            <a href={file} target="_blank" rel="noreferrer">
              تحميل الملف {i + 1}
            </a>
          </Typography>
        ))}
      </Box>
    )}
  </Box>
)}

      {/* 📝 السطر الثالث */}
      <Box
        sx={{
          mt: 1.5,
          p: 1.5,
          bgcolor: "rgba(255,255,255,0.6)",
          borderRadius: 1.5,
          border: "1px solid rgba(0,0,0,0.06)",
        }}
      >
        <Typography variant="caption" color="text.secondary" fontWeight={700}>
          📝 التاسك
        </Typography>
        <TaskText task={task} />
      </Box>
      
{/* عرض إثبات الإكمال إذا كانت المهمة مكتملة */}
{task.status === "completed" && task.completionProof && (
  <Box mt={2} sx={{ backgroundColor: "#e8f5e9", p: 2, borderRadius: 2 }}>
    <Typography fontWeight="bold" gutterBottom>
      🏁 إثبات الإكمال:
    </Typography>

    {/* ملاحظة الإكمال */}
    {task.completionProof.note && (
      <Typography sx={{ mb: 1 }}>
        📝 <strong>ملاحظة:</strong> {task.completionProof.note}
      </Typography>
    )}

    {/* الصور */}
    {task.completionProof.images?.length > 0 && (
      <Box display="flex" flexWrap="wrap" gap={1} mt={1}>
        {task.completionProof.images.map((img, i) => (
          <img
            key={i}
            src={img}
            alt={`proof-img-${i}`}
            style={{
              width: "100px",
              height: "100px",
              borderRadius: "8px",
              objectFit: "cover",
              cursor: "pointer",
              border: "1px solid #ccc",
            }}
            onClick={() => setPreviewImage(img)} // 👈 يفتح الصورة بالحجم الكامل
          />
        ))}
      </Box>
    )}

    {/* الملفات */}
    {task.completionProof.files?.length > 0 && (
      <Box mt={1}>
        {task.completionProof.files.map((file, i) => (
          <div key={i}>
            📎{" "}
            <a href={file} target="_blank" rel="noopener noreferrer">
              ملف رقم {i + 1}
            </a>
          </div>
        ))}
      </Box>
    )}

    {/* وقت الإكمال */}
    {task.completionProof.completedAt && (
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: "block", mt: 1 }}
      >
        ⏰ أُكمل بتاريخ:{" "}
        {toDateSafe(task.completionProof.completedAt).toLocaleString("ar-IQ")}
      </Typography>
    )}
  </Box>
)}

      {/* 💬 التعليقات داخل قائمة منطيّة */}
      <Accordion sx={{ mt: 2, bgcolor: "#fafafa" }}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          💬 التعليقات ({task.comments?.length || 0})
        </AccordionSummary>
        <AccordionDetails>
         {task.comments?.length > 0 ? (
  task.comments.map((c, i) => (
    <Paper key={i} sx={{ p: 1, mb: 1, backgroundColor: "#f9f9f9" }}>
      <Typography variant="body2">
        <strong>{c.by}:</strong> {c.text}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {toDateSafe(c.timestamp)?.toLocaleString("ar-IQ")}
      </Typography>

      {/* عرض الصور إن وجدت */}
      {c.attachments?.images?.length > 0 && (
        <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
          {c.attachments.images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt="attachment"
              style={{
                width: 80,
                height: 80,
                objectFit: "cover",
                borderRadius: 6,
                cursor: "pointer",
                border: "1px solid #ddd",
              }}
              onClick={() => setPreviewImage(img)}
            />
          ))}
        </Box>
      )}

      {/* عرض الملفات */}
      {c.attachments?.files?.length > 0 && (
        <Box mt={1}>
          {c.attachments.files.map((file, idx) => (
            <div key={idx}>
              <a href={file} target="_blank" rel="noopener noreferrer">
                📂 ملف رقم {idx + 1}
              </a>
            </div>
          ))}
        </Box>
      )}
    </Paper>
  ))

          ) : (
            <Typography color="text.secondary">
              لا توجد تعليقات بعد
            </Typography>
          )}

          <Box mt={1}>
            <Button
              size="small"
              variant="outlined"
              onClick={() => {
                setActiveTask(task);
                setCommentOpen(true);
                setCommentNewStatus("");

              }}
            >
              ➕ إضافة تعليق
            </Button>
          </Box>
        </AccordionDetails>
      </Accordion>

      {/* 🗑️ زر الحذف */}
      <Box textAlign="left" mt={1}>
   <Button
  color="error"
  variant="contained"
  onClick={() => setDeleteTarget(task)} // يفتح نافذة "هل أنت متأكد؟"
>
  🗑️ حذف
</Button>
<Button
  color="primary"
  variant="contained"
  sx={{ ml: 1 }}
  onClick={() => {
    setEditMode(true);
    setEditingTask(task);

    setTaskText(task.text);
    setTaskHtml(task.textHtml || plainTextToHtml(task.text || ""));
    setEditorKey((k) => k + 1);
    setTaskEmployee(task.employee);
    setTaskDeadline(task.deadline || "");
    setTaskPriority(task.priority || ""); // ⭐ هذا السطر هو الحل

    // ✅ المهم جداً
    setExistingImages(task.images || []);
    setExistingFiles(task.files || []);

    setTaskImages([]); // صور جديدة فقط
    setTaskFiles([]);  // ملفات جديدة فقط

    setOpen(true);
  }}
>
  ✏️ تعديل
</Button>



      </Box>
 </Paper>
);
})}
</Box>


      {/* Popup: إضافة تاسك */}
     <Dialog
  open={open}
  onClose={() => {
    if (!isSubmitting) {
      setOpen(false);
      setEditMode(false);
      setEditingTask(null);
    }
  }}
  fullWidth
  maxWidth="md"
>
  <DialogTitle>
    {editMode ? "✏️ تعديل التاسك" : "➕ إضافة تاسك"}
  </DialogTitle>

        <DialogContent>
          <Typography fontWeight={700} sx={{ mb: 1, mt: 1 }}>
            📝 وصف التاسك
          </Typography>
          <Box sx={{ mb: 3 }}>
            <RichTextEditor
              key={editorKey}
              initialHtml={taskHtml}
              disabled={isSubmitting}
              onChange={({ html, text }) => {
                setTaskHtml(html);
                setTaskText(text);
              }}
            />
          </Box>
          <FormControl fullWidth sx={{ mb: 2 }} disabled={isSubmitting}>
            <InputLabel>الموظف</InputLabel>
            <Select
              value={taskEmployee}
              onChange={(e) => setTaskEmployee(e.target.value)}
            >
            {EMPLOYEES.filter((e) => !NO_NEW_TASK_EMPLOYEES.includes(e)).map((e) => (
                <MenuItem key={e} value={e}>{TASK_EMPLOYEE_LABELS[e] || e}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }} disabled={isSubmitting}>
  <InputLabel>الأولوية</InputLabel>
  <Select
    value={taskPriority}
    onChange={(e) => setTaskPriority(e.target.value)}
  >
        <MenuItem value="">-</MenuItem>
    <MenuItem value="High">🔴 High</MenuItem>
    <MenuItem value="Medium">🟡 Medium</MenuItem>
    <MenuItem value="Low">🟢 Low</MenuItem>
  </Select>
</FormControl>

        <TextField
  fullWidth
  type="date"
  label="Deadline (اختياري)"
  InputLabelProps={{ shrink: true }}
  value={taskDeadline}
  onChange={(e) => setTaskDeadline(e.target.value)}
 inputProps={
  editMode
    ? {} // تعديل تاسك قديم → اسمح بالتاريخ القديم
    : { min: new Date().toISOString().split("T")[0] } // إضافة جديدة → امنع القديم
}

  sx={{ mb: 2 }}
  disabled={isSubmitting}
/>

{existingImages.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">📷 صور مرفقة:</Typography>
    <Box display="flex" gap={1} flexWrap="wrap">
      {existingImages.map((img, i) => (
        <Box key={i} position="relative">
          <img
            src={img}
            alt="old"
            style={{
              width: 90,
              height: 90,
              objectFit: "cover",
              borderRadius: 8,
              cursor: "pointer",
            }}
            onClick={() => setPreviewImage(img)}
          />
          <Button
            size="small"
            color="error"
            sx={{
              position: "absolute",
              top: -6,
              right: -6,
              minWidth: 24,
              height: 24,
              borderRadius: "50%",
            }}
            onClick={() =>
              setExistingImages(existingImages.filter((_, idx) => idx !== i))
            }
          >
            ✕
          </Button>
        </Box>
      ))}
    </Box>
  </Box>
)}

          {/* رفع الصور */}
          <Button component="label" disabled={isSubmitting} sx={{ mr: 2 }}>
            📷 رفع صور
            <input
              type="file"
              hidden
              multiple
              accept="image/*"
onChange={(e) =>
  setTaskImages((prev) => [...prev, ...Array.from(e.target.files)])
}
            />
          </Button>
          <Typography display="inline">{taskImages.length} صورة</Typography>
{/* معاينة الصور + حذف */}
{taskImages.length > 0 && (
  <Box mt={2} display="flex" gap={1} flexWrap="wrap">
    {taskImages.map((img, i) => (
      <Box key={i} position="relative">
        <img
          src={URL.createObjectURL(img)}
          alt="preview"
          style={{
            width: 90,
            height: 90,
            objectFit: "cover",
            borderRadius: 8,
            border: "1px solid #ccc",
          }}
        />
        <Button
          size="small"
          color="error"
          onClick={() =>
            setTaskImages(taskImages.filter((_, idx) => idx !== i))
          }
          sx={{
            position: "absolute",
            top: -8,
            right: -8,
            minWidth: 24,
            height: 24,
            borderRadius: "50%",
            padding: 0,
          }}
        >
          ✕
        </Button>
      </Box>
    ))}
  </Box>
)}
{existingFiles.length > 0 && (
  <Box mt={2}>
    <Typography fontWeight="bold">📎 ملفات مرفقة:</Typography>
    {existingFiles.map((file, i) => (
      <Box
        key={i}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          border: "1px solid #ddd",
          borderRadius: 1,
          p: 1,
          mb: 1,
        }}
      >
        <a href={file} target="_blank" rel="noreferrer">
          ملف {i + 1}
        </a>
        <Button
          size="small"
          color="error"
          onClick={() =>
            setExistingFiles(existingFiles.filter((_, idx) => idx !== i))
          }
        >
          حذف
        </Button>
      </Box>
    ))}
  </Box>
)}

          {/* رفع الملفات */}
          <Box mt={1}>
            <Button component="label" disabled={isSubmitting} sx={{ mr: 2 }}>
              📎 رفع ملفات
              <input
                type="file"
                hidden
                multiple
                onChange={(e) => appendPickedFiles(e, setTaskFiles)}
              />
            </Button>
            <Typography display="inline">{taskFiles.length} ملف</Typography>
            {/* معاينة الملفات + حذف */}
{taskFiles.length > 0 && (
  <Box mt={2}>
    {taskFiles.map((file, i) => (
      <Box
        key={i}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          border: "1px solid #ddd",
          borderRadius: 1,
          p: 1,
          mb: 1,
        }}
      >
        <Typography fontSize={14}>📎 {file.name}</Typography>
        <Button
          size="small"
          color="error"
          onClick={() =>
            setTaskFiles(taskFiles.filter((_, idx) => idx !== i))
          }
        >
          حذف
        </Button>
      </Box>
    ))}
  </Box>
)}

          </Box>
        </DialogContent>
    <DialogActions>
  <Button
    disabled={isSubmitting}
    onClick={() => {
      setOpen(false);
      setEditMode(false);
      setEditingTask(null);


       // تصفير الحقول
    setTaskText("");
    setTaskHtml("");
    setTaskEmployee("");
    setTaskDeadline("");
    setTaskPriority("");
    setTaskImages([]);
    setTaskFiles([]);
    setExistingImages([]);
    setExistingFiles([]);
    }}
  >
    إلغاء
  </Button>

  {/* ➕ إضافة تاسك جديد */}
  {!editMode && (
    <Button
      onClick={handleAddTask}
      variant="contained"
      disabled={isSubmitting || !taskEmployee || !taskText.trim()}
      startIcon={isSubmitting ? <CircularProgress size={18} /> : null}
    >
      {isSubmitting ? "جارٍ الإرسال..." : "➕ إرسال"}
    </Button>
  )}

  {/* ✏️ تعديل تاسك موجود */}
  {editMode && (
    <>
     

      <Button
        variant="contained"
        color="warning"
        disabled={isSubmitting}
        onClick={() => handleUpdateTask("pending")}
      >
        🔄 حفظ + Pending
      </Button>

      <Button
        variant="contained"
        color="info"
        disabled={isSubmitting}
        onClick={() => handleUpdateTask("inProgress")}
      >
        ⏳ حفظ + قيد العمل
      </Button>
    </>
  )}
</DialogActions>


      </Dialog>

      {/* Popup: تفاصيل التاسك */}
      <Dialog
        open={!!selectedTask}
        onClose={() => setSelectedTask(null)}
        fullWidth
      >
        <DialogActions>
  <Button onClick={() => setSelectedTask(null)}>إغلاق</Button>
  <Button
    color="error"
    variant="contained"
    onClick={() => setDeleteTarget(selectedTask)}
  >
    🗑️ حذف
  </Button>
  
  
</DialogActions>

        <DialogTitle>📋 تفاصيل التاسك</DialogTitle>
        <DialogContent>
          <Typography>👤 الموظف: {selectedTask?.employee}</Typography>
          <Typography component="div">📝 الوصف: <TaskText task={selectedTask} /></Typography>
          <Typography>🗓️ أُضيف بتاريخ: {formatDateTime(selectedTask?.createdAt)}</Typography>
          <Typography>⏳ الديدلاين: {selectedTask?.deadline || "مفتوح"}</Typography>
          <Typography>📌 الحالة: {selectedTask?.status}</Typography>

          {selectedTask?.images?.length > 0 && (
            <>
              <Typography mt={2}>📷 الصور:</Typography>
              {selectedTask.images.map((img, i) => (
                <img
                  key={i}
                  src={img}
                  alt={`img-${i}`}
                  style={{ maxWidth: "100%", margin: "6px 0", borderRadius: 8 }}
                />
              ))}
            </>
          )}

          {selectedTask?.files?.length > 0 && (
            <>
              <Typography mt={2}>📎 الملفات:</Typography>
              {selectedTask.files.map((file, i) => (
                <div key={i}>
                  <a href={file} target="_blank" rel="noopener noreferrer">
                    📂 ملف {i + 1}
                  </a>
                </div>
              ))}
            </>
          )}

          {selectedTask?.comments?.length > 0 && (
  <>
    <Typography mt={2}>💬 التعليقات:</Typography>
    {selectedTask.comments.map((c, i) => (
      <Paper key={i} sx={{ p: 1, mb: 1, backgroundColor: "#f9f9f9" }}>
        <Typography variant="body2">
          <strong>{c.by}:</strong> {c.text}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {toDateSafe(c.timestamp)?.toLocaleString("ar-IQ")}
        </Typography>
      </Paper>
    ))}
  </>
)}

        </DialogContent>
    
      </Dialog>
      {/* Popup: إضافة تعليق */}
<Dialog open={commentOpen} onClose={() => setCommentOpen(false)} fullWidth>
  <DialogTitle>📝 إضافة تعليق</DialogTitle>
  <DialogContent>
    <TextField
      fullWidth
      multiline
      rows={3}
      label="نص التعليق"
      value={commentText}
      onChange={(e) => setCommentText(e.target.value)}
      sx={{ mb: 2 }}
    />
<FormControl fullWidth sx={{ mb: 2 }}>
  <InputLabel>تغيير حالة التاسك بعد التعليق</InputLabel>
  <Select
    value={commentNewStatus}
    label="تغيير حالة التاسك بعد التعليق"
    onChange={(e) => setCommentNewStatus(e.target.value)}
  >
    <MenuItem value="">بدون تغيير</MenuItem>
    <MenuItem value="pending">⏳ Pending</MenuItem>
    <MenuItem value="inProgress">🕒 In Progress</MenuItem>
  </Select>
</FormControl>

    {/* 📷 رفع صور */}
    <Button component="label" sx={{ mr: 2 }}>
      📷 رفع صور
      <input
        type="file"
        hidden
        multiple
        accept="image/*"
        onChange={(e) => appendPickedFiles(e, setCommentImages)}
      />
    </Button>
    <Typography display="inline">{commentImages.length} صورة</Typography>
    <UploadPreview files={commentImages} onChange={setCommentImages} />

    {/* 📎 رفع ملفات */}
    <Box mt={1}>
      <Button component="label" sx={{ mr: 2 }}>
        📎 رفع ملفات
        <input
          type="file"
          hidden
          multiple
          onChange={(e) => appendPickedFiles(e, setCommentFiles)}
        />
      </Button>
      <Typography display="inline">{commentFiles.length} ملف</Typography>
    <UploadPreview files={commentFiles} onChange={setCommentFiles} />
    </Box>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setCommentOpen(false)}>إلغاء</Button>
   <Button
  variant="contained"
  disabled={isUploadingComment}
  startIcon={isUploadingComment ? <CircularProgress size={18} color="inherit" /> : null}
  onClick={async () => {
    if (!commentText.trim()) return;
    try {
      setIsUploadingComment(true); // ⏳ بدأ التحميل

      let imageUrls = [];
      let fileUrls = [];

      // رفع الصور
      for (const img of commentImages) {
        const imgRef = ref(storage, `tasks/comments/${Date.now()}-${img.name}`);
        await uploadBytes(imgRef, img);
        imageUrls.push(await getDownloadURL(imgRef));
      }

      // رفع الملفات
      for (const f of commentFiles) {
        const fRef = ref(storage, `tasks/comments/${Date.now()}-${f.name}`);
        await uploadBytes(fRef, f);
        fileUrls.push(await getDownloadURL(fRef));
      }

      const newComment = {
        by: currentUser,
        text: commentText.trim(),
        attachments: { images: imageUrls, files: fileUrls },
        timestamp: null, // السيرفر يحسبها فعلياً
      };

      const commentRes = await apiFetch(`${API_BASE}/tasks/${activeTask.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          comments: [...(activeTask.comments || []), newComment],
          ...(commentNewStatus
            ? { status: commentNewStatus, updatedAt: true }
            : {}),
        }),
      });

      if (!commentRes.ok) {
        const errData = await commentRes.json().catch(() => ({}));
        throw new Error(errData.error || "فشل حفظ التعليق");
      }


      // ✅ إعادة التهيئة بعد الرفع
      setCommentText("");
      setCommentImages([]);
      setCommentFiles([]);
      setCommentNewStatus("");

      setCommentOpen(false);
      fetchTasks();
    } catch (err) {
      console.error("❌ خطأ أثناء حفظ التعليق:", err);
    } finally {
      setIsUploadingComment(false); // ✅ انتهاء التحميل
    }
  }}
>
  
  {isUploadingComment ? "جاري الرفع..." : "حفظ"}
</Button>

  </DialogActions>
</Dialog>
<Dialog
  open={!!previewImage}
  onClose={() => setPreviewImage(null)}
  fullScreen
  PaperProps={{
    style: {
      backgroundColor: "rgba(0, 0, 0, 0.85)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      overflow: "hidden",
    },
  }}
>
  {/* زر الإغلاق */}
  <Button
    onClick={() => setPreviewImage(null)}
    sx={{
      position: "absolute",
      top: 20,
      right: 20,
      color: "white",
      fontSize: "1rem",
      fontWeight: "bold",
      backgroundColor: "rgba(255,255,255,0.15)",
      "&:hover": { backgroundColor: "rgba(255,255,255,0.3)" },
      borderRadius: "50%",
      minWidth: "40px",
      height: "40px",
    }}
  >
    ❌
  </Button>

  {/* الصورة */}
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      height: "100%",
    }}
  >
    <img
      src={previewImage}
      alt="preview"
      style={{
        maxWidth: "90%",
        maxHeight: "90%",
        borderRadius: "10px",
        objectFit: "contain",
        boxShadow: "0 0 40px rgba(0,0,0,0.5)",
      }}
    />
  </Box>
</Dialog>

      {/* 🗑️ تأكيد حذف التاسك */}
      <ConfirmDialog
        open={!!deleteTarget}
        title="هل أنت متأكد من حذف التاسك؟"
        description={`سيتم حذف تاسك "${deleteTarget?.employee || ""}" نهائياً مع تعليقاته، ولا يمكن التراجع عن هذا الإجراء.`}
        confirmLabel="🗑️ نعم، احذف"
        cancelLabel="إلغاء"
        destructive
        loading={isDeleting}
        onConfirm={confirmDeleteTask}
        onCancel={() => !isDeleting && setDeleteTarget(null)}
      >
        {deleteTarget?.text && (
          <Box
            sx={{
              p: 1.5,
              bgcolor: "#f5f5f5",
              borderRadius: 1,
              fontSize: 14,
              maxHeight: 120,
              overflow: "hidden",
              overflowWrap: "anywhere",
            }}
          >
            {deleteTarget.text.length > 180 ? deleteTarget.text.slice(0, 180) + "…" : deleteTarget.text}
          </Box>
        )}
      </ConfirmDialog>

    </Container>
  );
};

export default TasksDashboard;
